export class Toast {
  private scene: any
  private container: any
  private initialized: boolean = false
  constructor(scene: any) {
    this.scene = scene
    this.container = scene.add.container(0, 0)
  }

  private ensureRoot() {
    if (!this.initialized) {
      this.initialized = true
      const bg = this.scene.add.rectangle(0, 0, 420, 40, 0x000000, 0.7)
      bg.setOrigin(0.5, 0)
      const text = this.scene.add.text(0, 8, '', { color: '#ffffff', fontFamily: 'Arial', fontSize: '14px' })
      text.setOrigin(0.5, 0)
      this.container.add([bg, text])
      this.container.setDepth(9999)
    }
  }

  show(message: string, durationMs: number = 2500) {
    this.ensureRoot()
    const [bg, text] = this.container.list as any[]
    ;(text as any).setText?.(message)
    const { width } = this.scene.scale
    this.container.setX(width / 2)
    this.container.setY(20)
    this.container.setVisible(true)
    this.scene.time.delayedCall(durationMs, () => {
      this.container.setVisible(false)
    })
  }
}

export default Toast
